<template>
  <div v-if="imgs.length <= 1" class="single img-wrapper" :class="{ 'is-print-show': show }">
    <!-- 处方单打印图片 -->
    <img
      :style="{
        width: width + 'px',
        top: width * idx + 'px'
      }"
      v-for="(src, idx) in imgs"
      ref="printImage"
      :key="src"
      :src="src"
      class="print-img"
      @error="onError"
      @load="onLoadImg(src, $event)"
      alt
    />
  </div>
  <div v-else class="multi img-wrapper" :class="{ 'is-print-show': show }">
    <!-- 处方单打印图片 -->
    <img
      :style="{
        width: width + 'px',
        top: width * idx + (idx + 1) * 5 + 25 + 'px',
        transform: 'rotate(90deg) translateY(-' + (750 - width) / 2 + 'px) translateX(-' + (750 - width) / 2 + 'px)'
      }"
      v-for="(src, idx) in imgs"
      ref="printImage"
      :key="src"
      :src="src"
      class="print-img"
      @error="onError"
      @load="onLoadImg(src, $event)"
      alt
    />
  </div>
</template>

<script>
/**
 * A4值规格：w 650px  h 980px;
 * 处方图片比例：w / h = 0.62
 * */
// 收集已经加载好的图片，再次使用该图片不会触发load
export default {
  name: 'PrintPrescriptionImg',
  data() {
    return {
      show: false,
      imgs: [],
      count: 0,
      newImgCount: 0,
      cb: null
    };
  },
  computed: {
    width() {
      if (this.imgs.length <= 1) return 750;
      return 950 / this.imgs.length - 5;
    }
  },
  methods: {
    // 图片load后直接打印
    onLoadImg(src, e) {
      this.count++;
      if (this.count === this.newImgCount) {
        this.onPrint();
      }
    },
    init(source, cb) {
      // 如果传入的图片为空直接抛错
      if (source.indexOf(undefined) > -1 || source.indexOf('') > -1) return this.onError();
      this.show = true;
      const oldImg = this.imgs;
      this.imgs = source;
      this.count = 0;
      this.newImgCount = 0;
      this.cb = cb;
      // 排除原先已有的img
      for (let src of source) {
        if (oldImg.indexOf(src) === -1) {
          this.newImgCount++;
        }
      }
      this.$nextTick(() => {
        if (this.newImgCount === 0) this.onPrint();
      });
    },
    onError() {
      this.$message.error('处方图片加载失败');
      // 清空所有图片防止错误的图片继续放进去旧的图片池判断
      this.imgs = [];
    },
    onPrint() {
      window.print();
    },
    onAfterPrint() {
      this.cb && this.cb();
    }
  },
  created() {
    const printMedia = window.matchMedia('print');
    const printChange = ({ matches }) => {
      this.show = false;
      if (!matches) {
        this.onAfterPrint();
      }
    };
    printMedia.addEventListener('change', printChange);
    this.$once('hook:beforeDestroy', () => {
      printMedia.removeEventListener('change', printChange);
    });
  }
};
</script>

<style lang="less" scoped>
.img-wrapper {
  display: none;
  width: 750px;
  height: 980px;
}
.single {
  padding-top: 20px;
  .print-img {
    width: 750px;
    height: 960px;
    object-fit: contain;
  }
}

.img-wrapper {
  text-align: center;

  &.multi {
    position: relative;
    overflow: hidden;
    .print-img {
      display: block;
      position: absolute;
      left: 0;
      height: 750px;
      object-fit: contain;
      // transform-origin: center;
    }
  }
}
</style>
